import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, FormControl, Validators } from "@angular/forms";
import { Customer } from "@app/core/models/customer.model";
import { ActivatedRoute, Router } from "@angular/router";
import { BooleanInput } from "@angular/cdk/coercion";
import { CustomerService } from "@app/core/services/customer.service";
import { UserAlertService } from "@app/shared/services/user-alert.service";
import { CustomerInternet } from '@app/core/models/customer-internet.model';
import { DialogData } from '@app/shared/models/dialog-data';
import { DialogAction } from '@app/shared/models/dialog-action';
import { DialogComponent } from '@app/shared/components/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-customer-website',
  templateUrl: './customer-website.component.html',
  styleUrls: ['./customer-website.component.css']
})
export class CustomerWebsitePageComponent implements OnInit{
	@Input()
	parentForm!: FormGroup;
	private _initialDetails?: CustomerInternet = undefined;
	private _readonly: BooleanInput = true;
	customer?: Customer;
	customerInternet?: CustomerInternet;
	selections?: SelectionModel<CustomerInternet>;
	agency?: Customer;
	form!: FormGroup;
	id: FormControl;
	address: FormControl;
	description: FormControl;

	isReadOnly()  {
		return false;
	}

	isValid() {
		return this?.form?.status == "VALID";
	}


	initDefaults() {
			// return any values back to initial states
			if (this.form && this != undefined && this.customerInternet != undefined) {
				this.setFormValueIfNotEmpty("id", this.customerInternet.id);
				this.setFormValueIfNotEmpty("address", this.customerInternet.address);
				this.setFormValueIfNotEmpty("description", this.customerInternet.description);
			}
	}

	clickEditButton() {
		this._readonly = !this._readonly;
		if (this._readonly) {
			this.initDefaults();
		}

	}

	constructor(private formBuilder: FormBuilder,
				private _route: ActivatedRoute,
				private _router: Router,
				private _userAlertService: UserAlertService,
				private _dialog: MatDialog,
				private _customerService: CustomerService

		) { //}, private appConfigService: AppConfigService) {
		this.id = this.formBuilder.control(this._initialDetails?.id || "");
		this.address = this.formBuilder.control(this._initialDetails?.address || "", [Validators.required, Validators.maxLength(256)]);
		this.description = this.formBuilder.control(this._initialDetails?.description || "", [Validators.required, Validators.maxLength(120)]);
		const nav = this._router.getCurrentNavigation();
		if (nav && nav.extras && nav.extras.state) {
			this.customer = nav.extras.state['customer'];
			this.agency = nav.extras.state['agency'];
			this.selections = nav.extras.state['selections'];
			this.customerInternet = nav.extras.state['internet'];
			//if (this?.selections?.selected && this?.selections?.selected?.length > 0) {
			//	this.customerInternet = this.selections?.selected[0]; // first one will do for now.
			//}
		}
		this.form = new FormGroup({});
		this._dialog = _dialog;
	}

	getCustomerInternetDetails(): CustomerInternet {

		const customerInternetDetails = new CustomerInternet();

		customerInternetDetails.id = this.getFormValueIfNotEmpty('id');
		customerInternetDetails.address = this.getFormValueIfNotEmpty('address');
		customerInternetDetails.description = this.getFormValueIfNotEmpty('description');
		return customerInternetDetails;
	}

	ngOnInit(): void {
		//this.form = this.parentForm;
		this.form.addControl("id", this.id);
		this.form.addControl("address", this.address);
		this.form.addControl("description", this.description);
		if (this.customer) {
			this._initialDetails = this.customer;
			this.initDefaults();
		}
	}

	private setFormValueIfNotEmpty(fieldName: string, fieldValue?: string) {
		if (this.form && fieldValue) {
			this.form.controls[fieldName].setValue(fieldValue);
		}
	}
	private getFormValueIfNotEmpty(fieldName: string)  {
		return this.form?.controls[fieldName]?.value;
	}

	modifyCustomerWebsite() {
		if (this != undefined && this.customer != undefined) {
			const customerInternet = this.getCustomerInternetDetails();
			var modified = false;
			// make sure there is an website collection.
			if (this.customer?.urls == undefined ) {
				if (this && this.customer) {
				this.customer.urls = [];
				}
			}
			if (this.selections == undefined) {
				this.customer.urls?.push(customerInternet);
				modified = true;
			}
			else if (this && this.customer && this.customer.urls) {
				for(var index = 0; index < this.customer.urls.length; index++) {
					if (this.customer.urls[index].id == customerInternet.id) {
						this.customer.urls[index] = customerInternet;
						modified = true;
						break;
					}
				}
			}
			if (modified) {
				this._customerService.createOrUpdateCustomer(this?.agency?.id, this.customer).
				subscribe(
					updatedCustomer => {
						this._router.navigate(["advertiser"], { state: { customer: updatedCustomer, agency: this.agency } });
					},
					// TODO NOT SURE WHAT WE WANT TO DO FOR ERROR HANDLING
					error => { this._userAlertService.error("FAILED")});

			} else {
				this._router.navigate(["advertiser"], { state: { customer: this.customer, agency: this.agency } });
			}
		}
	}


	confirmDeleteCustomerWebsite(): void {
		const submitActionId = "delete";
		const dialogData = new DialogData();
		dialogData.messageKey = "CUSTOMER_DETAILS.DELETE_CONFIRMATION_MESSAGE.CONFIRM_REMOVE_WEBSITE";
		dialogData.actions = [
			new DialogAction(submitActionId, "ACTION_BUTTON_LABELS.DELETE", true),
			new DialogAction("", "ACTION_BUTTON_LABELS.CANCEL", false),
		];
		const dialogRef = this._dialog.open(DialogComponent, { data: dialogData	});
		dialogRef.afterClosed().subscribe({
			next: (actionId: string) => {
				if (actionId === submitActionId) this.deleteCustomerWebsite();
			}
		});
	}

	deleteCustomerWebsite() {
		if (this != undefined && this.customer != undefined && this.customerInternet != undefined && this.customer.urls != undefined) {
			var modified = false;
			// any contacts we wish to remove... remove them
			const internet  = this.customerInternet;
			for(var index = this.customer.urls.length-1; index >= 0; index--) {
				if (this.customer.urls[index].id == internet?.id) {
					//this.customer.contacts[index].id = "DELETE + "
					this.customer.urls.splice(index,1);
					modified = true;
					break;
				}
			}
			// once removed we then delete them from the customer.
			if (modified) {
					this._customerService.createOrUpdateCustomer(this?.agency?.id, this.customer).
					subscribe(
						updatedCustomer => {
							this.customer = updatedCustomer;
							this._router.navigate(["advertiser"], { state: { customer: updatedCustomer, agency: this.agency } });
						},
						// TODO NOT SURE WHAT WE WANT TO DO FOR ERROR HANDLING
						error => { this._userAlertService.error("FAILED:${error}")});
			} else {
				this._router.navigate(["advertiser"], { state: { customer: this.customer, agency: this.agency } });
			}
		}
	}

	closeCustomerWebsite() {
		if (this && this.customer) {
			this._router.navigate(["advertiser"], { state: { customer: this.customer, agency: this.agency } });
		}
	}

}
